<template>
  <div class="loadContainer">
    <!-- 序列帧 -->
    <div class="seq">
      <!-- 序列帧播放 -->
      <swiper-play :swiper="swiper" />
    </div>
    <!-- 文字 -->
    <div :class="['text', {textFont:loadFont}, {textMedia:dev}]">
      读<br />取<br />中<span class="line">.<br />.<br />.</span>
    </div>
  </div>
</template>

<script>
import SwiperPlay from "../../swiperPlay";
export default {
  name: "LoadContainer",
  components: {
    SwiperPlay
  },
  computed: {
    // 序列帧
    swiper() {
      let r = [];
      for (let i = 0; i < 16; i++) {
        r.push(require(`@/assets/img/loading/a${i}.png`));
      }
      return r;
    },
    loadFont() {
      return this.$store.state.loadFont;
    },
    dev() {
      return this.$store.state.dev;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/com.scss";
.loadContainer {
  @include wh(100%, 4.83rem);
  position: absolute;
  bottom: 0;
  .text {
    @include LRcenter;
    @include wh(0.4rem, 3.8rem);
    bottom: 0;
    text-align: center;
    font-size: 0.3rem;
    font-family: "Microsoft YaHei";
    color: white;
    @media all and (max-width: 990px) {
      font-size: 0.4rem;
    }
    .line {
      display: block;
      line-height: 0.2rem;
    }
  }
  .textMedia {
    font-size: 0.4rem;
  }
  .textFont {
    font-family: "fz";
  }
}
.seq {
  @include wh(0.8rem, 0.8rem);
  @include LRcenter;
  top: 0;
}
</style>


